import React from 'react';
import Header from './Components/Header';
import "./Components/style.css";
import Feature from "./Components/Feature";
import About from "./Components/About";
import aboutimage from "./images/Frame 19.png";
import aboutimage1 from "./images/download.png";
import Presentation from './Components/Presentation';
import Contact from './Components/Contact';
//import {motion} from "framer-motion";
function App() {
  return (
    <div className="App">
   <>
<Header/>
<About image={aboutimage} title='we love you the way you are ' button ='get app now'/>
<Feature/>
<About image={aboutimage} title='we bring happiness ' button ='get app now'/>
<Presentation/>

<Contact/>
   </>

    </div>
  );
}

export default App;
